import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ReferenceService } from '../../generated/auth/services/reference.service';
import {
  loadBranchCodes,
  loadBranchCodesFailure,
  loadBranchCodesSuccess,
  toggleBranchCodesLoading,
} from './branch-codes.actions';

@Injectable()
export class BranchCodesEffects {
  private actions$ = inject(Actions);
  private referenceService = inject(ReferenceService);

  constructor() {}

  loadBranchCodes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBranchCodes),
      switchMap(() =>
        this.referenceService.referenceSasSecLookupGetBranchPartnersGet().pipe(
          map((response) => {
            const branchPartners = response.result || [];
            return loadBranchCodesSuccess({ branchPartners });
          }),
          catchError((error) => of(loadBranchCodesFailure({ error }))),
        ),
      ),
    ),
  );

  loadBranchCodesSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBranchCodesSuccess),
      map(() => toggleBranchCodesLoading({ loading: false })),
    ),
  );

  loadBranchCodesFailure$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBranchCodesFailure),
      map(() => toggleBranchCodesLoading({ loading: false })),
    ),
  );
}
